import { use, useEffect, useRef, useState } from "react";
import { useDebounce } from "./lib";
import { useMutation } from "@tanstack/react-query";
import { checkAggr } from "../../../Services/Api";
import useSound from "use-sound";
import err from '../sounds/err.mp3';
import { TextField, Typography } from "@mui/material";

const minAggrLength = 18; // Минимальная длина агрегационного кода
const maxAggrLength = 30; // Максимальная длина агрегационного кода

export const Stage1 = (props) => {
  const {
    setRezult = () => { },
    boxSize,
    barCode,
    withoutAgregation,
    aggLevelId, 

  } = props;
  const [playErr] = useSound(err);

  const aggrCodeFieldRef = useRef(null);

  const [aggrCode, setAggrCode] = useState(withoutAgregation ? 'БЕЗ-АГРЕГАЦИОННОГО' : '');
  const [errorMessage, setErrorMessage] = useState('');

  const mutation = useMutation({
    mutationKey: ['checkAggr', aggrCode, barCode, boxSize],
    mutationFn: checkAggr,
    onSuccess: (data) => {
      if (data?.payload?.status === 'ok') {
        setRezult(aggrCode, data?.payload?.productName || data?.payload?.produktName);
      } else {
        clear();
        setErrorMessage(data?.payload?.resultMessage || 'Ошибка проверки кода');
        playErr();
      }
      console.log('!!!Code check successful:', data?.payload?.status);
    },
    onError: (error) => {
      playErr();
      console.error('!!!Code check failed:', error);
      clear();
      setErrorMessage(error?.message ? (`Сетевая ошибка: ${error.message}`) : 'Непредвиденная сетевая ошибка');
    },
  });

  const clear = () => {
    setAggrCode('');
    if (aggrCodeFieldRef.current) {
      aggrCodeFieldRef.current.focus();
    }
  }


  useEffect(() => {
    if (!withoutAgregation) setAggrCode('');
    setErrorMessage('');
    if (aggrCodeFieldRef.current) {
      aggrCodeFieldRef.current.focus();
    }
  }, []);

  const dc = useDebounce(aggrCode, 200, (value) => {
    if (value) {
      if (value?.length >= minAggrLength && value?.length <= maxAggrLength) {
        mutation.mutate({ aggrCode: value, barCode, boxSize, aggLevelId });
      } else if (aggrCode?.length < minAggrLength || aggrCode?.length > maxAggrLength) {
        setErrorMessage(`Длина агрегационного кода должна быть от ${minAggrLength} до ${maxAggrLength} символов`);
        clear();
        playErr();
      }
    }
  });
  console.log('!!!initial code', { withoutAgregation, aggrCode, dc })


  return (
    <div >
      <div style={{ height: "20px", width: '100%', backgroundColor: "#EE22EE" }} >1</div>
      <Typography variant="body1" gutterBottom>
        Новая упаковка: Отсканируйте код упаковки
      </Typography>
      <div >
        <TextField
          inputRef={aggrCodeFieldRef}
          InputLabelProps={{ shrink: true }}
          label="Код упаковки"
          fullWidth
          size="small"
          value={aggrCode}
          onChange={(e) => setAggrCode(e?.target?.value || e)}
          error={!!errorMessage}
          helperText={!!errorMessage ? errorMessage : undefined}
        />
      </div>
    </div>
  );
}